import { useMutation } from "@tanstack/react-query";

import { compareCandidates } from "../services/candidate.services";
import { CompareCandidatesPayload, CompareCandidatesResponse } from "../types/candidate.types";

export const useCompareCandidates = () => {
  const {
    mutate: compareCandidatesMutate,
    mutateAsync: compareCandidatesMutateAsync,
    isPending,
    isError,
    error,
    data,
  } = useMutation<CompareCandidatesResponse, Error, CompareCandidatesPayload>({
    mutationFn: (payload: CompareCandidatesPayload) => compareCandidates(payload),
  });

  return {
    compareCandidatesMutate,
    compareCandidatesMutateAsync,
    isPending,
    isError,
    error,
    data,
  };
};
